import GoogleMapReact from "google-map-react";
import moment from "moment";


import supercluster from "points-cluster";
import React from "react";

import ActionBar from "../components/ActionBar";
import ClusterMarker from "../components/ClusterMarker";
import FloodMarker from "../components/FloodMarker";
import Loader from "../components/Loader";
import Marker from "../components/Marker";
import VLButton from "../components/VLButton";
import * as Constants from "../Constants";
import Sensor from "../Sensor";
import * as API from "../util/api";
import * as Render from "../util/Render";

import * as Util from "../util/util";
import * as Variant from "../util/variant";
import VLComponent from "./VLComponent";


class MapScreen extends VLComponent {

    infoBoxStyle = {
        width: 300,
        background: "white",
        textAlign: "center",
        fontSize: 14,
        borderColor: window.primary,
        borderSize: 0,
        borderStyle: "solid",
        borderRadius: 8,
        paddingTop: 8,
        overflow: "hidden",
        position: "absolute", transform: "translate(-50%, 0)"
    };

    constructor() {
        super();

        this.state = {
            loaded: false,
            sensors: [],
            floods: [],
            show_typical: true,
            show_below: true,
            show_flood: true,
            show_online: true,
            show_offline: true,
            show_flood1: true,
            show_flood2: true,
            show_flood3: true,
            clusters: [],
            polygonsDrawn: false,
        };
    }

    componentDidMount() {
        this.setState({group: this.props.group});

        Util.getLocation((pos) => {
            this.setState({lat: pos.coords.latitude, lng: pos.coords.longitude});
        });

        this.reload();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.floodId !== this.props.floodId) {
            this.reload();
        }
    }

    reload = () => {
        if (this.map) {
            this.map.data.forEach(feature => {
                this.map.data.remove(feature);
            });
        }
        this.setState({loaded: false});

        let params = {show_ea: true, show_nrw: true, show_floods: true};
        if (this.props.floodId != null) {
            //viewing all floods so remove polygons to avoid overloading the ui
            params.show_polygons = true;
            params.floodId = this.props.floodId;
        }
        API.POST("systems/list", params, result => {
            Util.handleLogout(result);
            if (result.success) {
                result.result.sensors.forEach(e => Object.setPrototypeOf(e, Sensor.prototype));


                if (this.props.floodId == null) {
                    //viewing all floods so remove polygons to avoid overloading the ui
                    result.result.floods.forEach(e => {
                        e.polygon = null;
                    });
                } else {
                    result.result.floods = result.result.floods.filter(e => e.uid == this.props.floodId);
                }

                this.setState(result.result);
                this.setState({refreshTime: moment().format("HH:mm:ss")});
                this.setState({loaded: true}, () => {
                    this.setupBounds();
                    this.drawPolygons();
                });
            }
        });
    };

    getClusters = () => {
        const sensors = this.showingSensors();
        const markersData = sensors.map((e, i) => ({
            id: i,
            lat: e.sensor_lat,
            lng: e.sensor_long
        }));
        const clusters = supercluster(markersData, {
            minZoom: 0,
            maxZoom: 16,
            radius: 60
        });

        let result = clusters(this.state.mapOptions);
        result.forEach(e => {
            e.points.forEach(f => {
                f.system = sensors[f.id];
            });
        });
        return result;
    };

    createClusters = () => {
        const clusters = this.state.mapOptions.bounds
            ? this.getClusters().map(({wx, wy, numPoints, points}) => ({
                lat: wy,
                lng: wx,
                numPoints,
                id: `${numPoints}_${points[0].id}`,
                points
            }))
            : [];
        this.setState({clusters});
    };

    handleMapChange = (prop) => {
        console.log("handle map change");
        console.log(prop);

        let {center, zoom, bounds} = prop;
        let mapOptions = {center, zoom, bounds};

        this.setState({mapOptions}, this.createClusters);
    };

    createOpts(maps) {
        return {
            zoomControlOptions: {
                position: maps.ControlPosition.RIGHT_CENTER,
                style: maps.ZoomControlStyle.SMALL
            },
            mapTypeControlOptions: {
                position: maps.ControlPosition.TOP_RIGHT
            },
            mapTypeControl: true,
            streetViewControl: true,
            rotateControl: true,
            scaleControl: true
        };
    }

    loadedMap = ({map, maps}) => {
        this.map = map;
        if (this.state.sensors.length > 0) {
            this.setupBounds();
        }

        map.data.setStyle(function (feature) {
            return {
                fillOpacity: 0.02,
                fillColor: "#ff0000",
                strokeColor: "red",
                strokeWeight: 1
            };
        });

        this.drawPolygons();
    };

    setupBounds = () => {
        const bounds = new window.google.maps.LatLngBounds();
        this.showingSensors().forEach(s => {
            let lat = s.sensor_lat;
            let lng = s.sensor_long;
            bounds.extend(new window.google.maps.LatLng(lat, lng));
        });
        if (this.map) {
            if (this.props.floodId == null) {
                this.map.fitBounds(bounds);
            } else {
                let flood = this.state.floods[0];
                if (flood) {
                    console.log(flood);
                    console.log("panning to flood");
                    this.map.setZoom(12);
                    this.map.panTo({lat: flood.lat, lng: flood.lng});
                }
            }
        }
    };

    mapClicked = (t, map, coord) => {
        this.setState({viewingSensor: null, viewingFlood: null});
    };

    render() {
        return (
            <div>
                <ActionBar title="Map "/>
                <Loader loaded={this.state.loaded}/>
                <div id="content" style={{width: "100%", visibility: this.state.loaded ? "visible" : "collapse"}}>
                    <div style={{height: "calc(100vh - 64px)", width: "100%", position: "relative"}}>
                        <GoogleMapReact
                            onChange={this.handleMapChange}
                            bootstrapURLKeys={{key: Constants.GOOGLE_MAPS_KEY}}
                            defaultCenter={{
                                lat: 53,
                                lng: 6.33
                            }}
                            defaultZoom={3}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={this.loadedMap}
                            onClick={this.mapClicked}
                            options={this.createOpts}>

                            {this.drawMarkers()}
                            {this.drawSensorInfo()}
                            {this.drawFloodInfo()}
                            {this.drawPolygons()}

                        </GoogleMapReact>
                        {Render.freeFormOverlay(this.filters())}
                    </div>


                </div>

            </div>
        );
    }

    viewArea = flood => {
        this.props.navigate("/floodArea/" + flood.uid);
    };

    drawPolygons = () => {
        if (this.map == null || this.state.polygonsDrawn) return;
        this.state.floods.filter(e => e.severity < 4 && e.polygon).forEach(flood => {
            const json = JSON.parse(flood.polygon);
            this.map.data.addGeoJson(json);
        });
        this.setState({polygonsDrawn: true});
    };

    drawFloodInfo = () => {
        const flood = this.state.viewingFlood;
        if (flood == null) return;

        const style = {...this.infoBoxStyle};
        style.background = "#33ccff";

        return <div lat={flood.lat} lng={flood.lng} style={style}>
            <h4>{flood.description}</h4>
            <p><i>{flood.regionName} - {flood.areaName}</i></p>
            <p>{flood.message}</p>
            <VLButton title="View Area" onClick={() => this.viewArea(flood)} className="bottom8"/>
        </div>;
    };

    drawSensorInfo = () => {
        let s = this.state.viewingSensor;
        if (s == null) return;

        const style = this.infoBoxStyle;

        //camera
        if (s.variant != Variant.GAUGE) {
            return <div lat={s.sensor_lat} lng={s.sensor_long}
                        style={style}>
                <p><b>{s.sensor_name}</b></p>
                <p>{s.sensor_postcode}</p>
                <p>Updated {s.sensor_comms}</p>
                <VLButton title="View" href={"/camera/" + s.sensor_id}/>
                <img src={s.sensor_image} style={{width: "100%", marginTop: 8}}/>
            </div>;
        }

        if (s.isEA()) {
            return <div lat={s.sensor_lat} lng={s.sensor_long}
                        style={style}>
                <p><b>{s.sensor_name}</b></p>
                <p>Updated {s.sensor_comms}</p>
                {this.renderInfoItem({
                    name: "Current Level",
                    colour: s.shouldRed() ? "red" : "green",
                    value: s.current_level
                })}

                {this.renderInfoItem({name: "Catchment", colour: "grey", value: s.catchment})}
                {this.renderInfoItem({name: "River", colour: "grey", value: s.riverName})}
                {this.renderInfoItem({
                    name: "Typical Range",
                    colour: "grey",
                    value: s.typicalLow + "m - " + s.typicalHigh + "m"
                })}
                <VLButton title="View" href={"/sensor/ea/" + s.sensor_id}/>
                <br/><br/>
            </div>;
        }
        if (s.isNRW()) {
            return <div lat={s.sensor_lat} lng={s.sensor_long}
                        style={style}>
                <p><b>{s.sensor_name}</b></p>
                <p>Updated {s.sensor_comms}</p>
                {this.renderInfoItem({
                    name: "Current Level",
                    colour: s.shouldRed() ? "red" : "green",
                    value: s.current_level
                })}

                {this.renderInfoItem({name: "Catchment", colour: "grey", value: s.catchment})}
                {this.renderInfoItem({name: "River", colour: "grey", value: s.riverName})}
                <VLButton title="View" href={"/sensor/nrw/" + s.sensor_id}/>
                <br/><br/>
            </div>;
        }

        //ls
        const fidoAlarms = s.fido_alarms_en ? [
            this.renderInfoItem({name: Util.alertLevelName() + " Level", colour: "grey", value: s.alert_level}),
            this.renderInfoItem({name: Util.actConLevelName() + " Level", colour: "grey", value: s.act_con_level}),
            this.renderInfoItem({name: Util.warningLevelName() + " Level", colour: "grey", value: s.warning_level})
        ] : null;
        return <div lat={s.sensor_lat} lng={s.sensor_long} style={style}>
            <p><b>{s.sensor_name}</b></p>
            <p>{s.sensor_postcode}</p>
            <p>Updated {s.sensor_comms}</p>
            {this.renderInfoItem({
                name: "Current Level",
                colour: s.shouldRed() ? "red" : "green",
                value: s.current_level
            })}
            {this.renderInfoItem({name: "Level Change", colour: "grey", value: s.level_change})}
            {fidoAlarms}
            {this.renderInfoItem({name: "Smartphone Level", colour: "grey", value: s.smartphone_warning})}
            <VLButton title="View" href={"/sensor/" + s.sensor_id}/>
            <br/><br/>
        </div>;
    };

    renderInfoItem = (info) => {
        return (

            <div style={{display: "flex"}}>
                <p style={{flex: 1, textAlign: "left"}}>{info.name}</p>
                <p style={{
                    flex: 1,
                    background: info.colour,
                    borderRadius: 16,
                    color: "white",
                    padding: 4
                }}>{info.value}</p>
            </div>

        );
    };

    filters = () => {
        return <div
            style={{
                background: "rgba(255,255,255,0.8)",
                margin: 16,
                padding: 16,
                borderRadius: 8,
                width: 240,
                border: "2px solid " + window.primary
            }}>

            <div>
                <h3>Level Sensors</h3>

                {this.filterRow("marker_green", "Typical Range", "show_typical")}
                {this.filterRow("marker_yellow", "Below Typical", "show_below")}
                {this.filterRow("marker_red", "Flood Risk", "show_flood")}

                <h3>Cameras</h3>

                {this.filterRow("cctv_green", "Online", "show_online")}
                {this.filterRow("cctv_blue", "Offline", "show_offline")}

                <h3>Flood Alerts</h3>

                {this.filterRow("flood3", "Severe", "show_flood1")}
                {this.filterRow("flood2", "Warning", "show_flood2")}
                {this.filterRow("flood1", "Alert", "show_flood3")}
            </div>
        </div>;
    };

    filterRow = (icon, name, key) => {
        let flip = () => {
            this.setState({[key]: !this.state[key]}, this.createClusters);
        };
        return <div style={{display: "flex", alignItems: "center", padding: "4px 0", select: "none"}}
                    className="hoverable" onClick={flip}>
            <img style={{width: 32, height: 32}} src={require("../icons/" + icon + ".png")}/>
            <p style={{flex: 1}}>{name}</p>
            <p style={{color: window.primary, fontWeight: 900}}>{this.state[key] ? "✓" : ""}</p>
        </div>;
    };

    showingSensors = () => {
        let id = this.props.id;
        if (id) {
            return this.state.sensors.filter(x => x.sensor_id == id);
        }
        return this.state.sensors.filter(e => {
            if (e.isCamera()) {
                return (this.state.show_online || !e.isOnline()) && (this.state.show_offline || e.isOnline());
            }

            return (this.state.show_typical || e.notTypical()) &&
                (this.state.show_below || e.notBelow()) &&
                (this.state.show_flood || e.notFlood());
        });
    };


    drawMarkers = () => {
        const sensors = this.state.clusters.map(item => {
            if (item.numPoints === 1) {
                console.log(item.points[0]);
                return (
                    <Marker
                        key={item.id}
                        lat={item.points[0].lat}
                        lng={item.points[0].lng}
                        system={item.points[0].system}
                        clicked={this.markerClicked}/>
                );
            }

            return (
                <ClusterMarker
                    key={item.id}
                    lat={item.lat}
                    lng={item.lng}
                    points={item.points}
                />
            );
        });

        const floods = this.state.floods.filter(e => e.severity < 4).filter(e => {
            const key = "show_flood" + e.severity;
            return this.state[key];
        }).map(flood => {
            return <FloodMarker flood={flood} lat={flood.lat} lng={flood.lng} clicked={this.floodClicked}/>;
        });
        return sensors.concat(floods);
    };

    markerClicked = (s) => {
        this.map.panTo(new window.google.maps.LatLng(s.sensor_lat, s.sensor_long));
        this.setState({viewingSensor: s, viewingFlood: null});
    };

    floodClicked = flood => {
        this.map.panTo(new window.google.maps.LatLng(flood.lat, flood.lng));
        this.setState({viewingFlood: flood, viewingSensor: null});
    };

}

export default MapScreen;
